import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuAction } from "./MenuAction";

export class MenuActionSwapPosition extends MenuAction {
    private siblingIndex: number;
    private direction: "up" | "down";
    constructor(node: MenuEditorTreeNode, direction: "up" | "down") {
        super(node);
        this.direction = direction;
    }

    override validate(): boolean {
        return this.node?.isTopLevelNode === true;
    }

    async internalExecute(): Promise<boolean> {
        const parentIndex = this.node.menuItem.parent.items.indexOf(this.node.menuItem);
        this.siblingIndex = parentIndex + (this.direction === "up" ? -1 : 1);
        const parentItems = this.node.menuItem.parent.items;
        const sibling = parentItems[this.siblingIndex];
        if (sibling == null) {
            return false;
        }
        const siblingGroup = sibling.groupReferenceData ?? sibling.groupData;
        const thisGroup = this.node.menuItem.groupReferenceData ?? this.node.menuItem.groupData;

        const thisPosition = thisGroup.get("item_position");
        const siblingPosition = siblingGroup.get("item_position");

        siblingGroup.set("item_position", thisPosition);
        thisGroup.set("item_position", siblingPosition);
        this.node.menuItem.parent.sortItems();
        this.menuItemToSelect = this.node.menuItem;
        return true;
    }
}
